import React from 'react'
import axios from "axios";
import SglContext from "../SglContext";
import './badEmailForm.css'
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

//API END POINTS
// const sgl_webservice_process_email_verification = Sgl.sglApiUrl+'/iphone.php/webservice/ProcessEmailVerification';

class BadEmailVerificationForm extends React.Component {
      
    get sgl_webservice_process_email_verification() {
      return this.context.sglApiUrl + '/iphone.php/webservice/ProcessEmailVerification';
    }

    state = {
        loading: true,
        company_name: '',
        email_confirmed: false
    }

    constructor() {
      super();
      // bind function in constructor instead of render
    }

    componentDidMount() {
        // this.checkUserSession();
        this.processEmailVerification();
    }
 
    processEmailVerification(){ 
        axios.all([
          axios.get(this.sgl_webservice_process_email_verification,{
            params : {
              customer_id: this.context.company_id,
              be_key: this.props.searchParams.get('be_key'),
              be_id: this.props.searchParams.get('be_id'),
              be_hash: this.props.searchParams.get('be_hash')
            }
          })
        ]).then(axios.spread((response) => {
          this.setState({
            loading: false,
            company_name: response.data.company_name,
            email_confirmed: response.data.success
          })
        }))
    }

    render(){
      const loading = this.state.loading;
      const company_name = this.state.company_name;
      const email_confirmed = this.state.email_confirmed;
      
      if(loading) {
        return null;
      }

      return(
        <div class="sgl-plugin">
          <div id="sgl-plugin-registration-success-message">
          {(() => {
            if (email_confirmed) {
              return (
                <div>
                  <h1>Thank You</h1>
                  <p>
                    Your email address has been confirmed for {company_name}!
                    <br /><br />
                    You may begin using {company_name} right away.  <br/><br/>You can now:
                    <br />
                  </p>
                  <ul>
                      <li>View your personal up-to-the-minute schedule</li>
                      <li>Get the Order-of-Go</li>
                      <li>View live ring status</li>
                      <li>Add and drop classes</li>
                      <li>See results and division totals</li>
                      <li>Order supplies</li>
                      <li>Checkout and pay your bill</li>
                  </ul>
                </div>
              )
            } else {
              return (
                <div> 
                  <h1>Error</h1>
                  <p>Processing error occurred.</p>  
                </div>
              )
            }
          })()}
          </div>
        </div>
      )
    }
  }
BadEmailVerificationForm.contextType = SglContext;
export default function (props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams()

  return <BadEmailVerificationForm {...props} navigate={navigate} searchParams={searchParams} />;
}